import React, { useState, useRef, useEffect } from 'react'

// Custom styles for component
import styles from './SwiperBook.module.scss'

const SwiperBookPagination = ({ items, jumpToChapter, triggerText }: any) => {
  const [navState, setNavState] = useState<boolean>(false)
  const [hovered, setHovered] = useState<boolean>(false)

  const mouseEnterHandler = () => setHovered(true)
  const mouseLeaveHandler = () => setHovered(false)
  const updateNavState = () => setNavState(true)

  const onTimeout = () => {
    setNavState(false)
  }

  useEffect(() => {
    const timer: any = !hovered && setTimeout(onTimeout, 1000)
    return () => {
      clearTimeout(timer)
    }
  }, [hovered])

  return (
    <div className={`Swiper__pagination ${styles.SwiperPagination}`}>
      <div className="SwiperBook__paginationList">
        <ul
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          className={navState ? 'show' : ''}
        >
          {items.map((chapter: any, index: number) => (
            <li
              key={index}
              onClick={() => {
                setNavState(false)
                jumpToChapter(chapter)
              }}
            >
              {chapter.chapterTitle}
            </li>
          ))}
        </ul>
      </div>
      <div
        className={`Swiper__paginationTrigger ${navState ? 'hide' : ''}`}
        onClick={updateNavState}
      >
        <span>{triggerText.title}</span>
      </div>
    </div>
  )
}

export default SwiperBookPagination
